import { Dialog } from '@headlessui/react'
import Lottie from 'lottie-react'
import Head from 'next/head'
import { ReactNodeLike } from 'prop-types'
import React, { FC, useEffect, useMemo } from 'react'
import { Toaster } from 'react-hot-toast'

import FloatingMenu from '@/components/FloatingMenus'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import { appName } from '@/config/env'
import { floatingMenuClearData } from '@/reducers/floating-menu'
import { useAppDispatch, useAppSelector } from '@/utils/hooks'

import loading from '~/assets/lottie/loading.json'

interface InterfaceLayouts {
  title: string
  description: string
  children?: ReactNodeLike
}
const Layouts: FC<InterfaceLayouts> = ({ title, children, description }) => {
  const dispatch = useAppDispatch()
  const appIsLoading = useAppSelector((state) => state.app.isLoading)
  const titleReady = useMemo(() => `${title} - ${appName}`, [])
  useEffect(() => {
    return () => {
      dispatch(floatingMenuClearData())
    }
  }, [])
  return (
    <>
      <Head>
        <title>{titleReady}</title>
        <meta
          name='description'
          content={description}
        />
      </Head>

      <Header />

      {children}

      <Dialog
        open={appIsLoading}
        onClose={() => null}
        className='fixed inset-0 z-menu flex h-full w-full items-center justify-center bg-black/80'
      >
        <Lottie
          animationData={loading}
          loop={true}
          className='h-15.5 w-15.5'
        />
      </Dialog>

      <Toaster />
      <Footer />
      <FloatingMenu />
    </>
  )
}

export default Layouts
